import styled from "styled-components";

export const Styled = styled.div`
  .ql-container {
    border-bottom-left-radius: 0.5em;
    border-bottom-right-radius: 0.5em;
    overflow-y: auto;
    max-width: 100%;
    width: 100%;
    height: 20vh;
  }

  .ql-container ::selection {
    background-color: rgb(145, 188, 239, 0.8);
  }

  .ql-editor.ql-blank::before {
    color: #c5c6ca !important;
    font-family: Lato !important;
    font-size: 16px !important;
    font-style: normal !important;
    font-weight: 400 !important;
    line-height: 24px !important;
  }

  /* Snow Theme */
  .ql-snow.ql-toolbar {
    display: flex;
    flex-direction: row;
    width: 100%;
    background: #eaecec;
    border-top-left-radius: 0.5em;
    border-top-right-radius: 0.5em;
    padding: 4px;
  }

  .ql-editor {
    counter-reset: initial;
    word-break: break-word;
    overflow-wrap: break-word;
  }

  /* Style the placeholder text */
  .ql-editor.ql-blank::before {
    font-style: italic;
    color: #888;
    opacity: 0.7;
  }

  .ql-editor li[data-list="bullet"] {
    counter-reset: list-0;
  }

  .ql-snow .ql-editor blockquote {
    border-left-color: #0081eb;
  }

  .ql-snow .ql-formats {
    display: flex;
    align-items: center;
  }
`;
